import React, {useCallback} from 'react';

const Fact = props => {
    const onSourceClick = useCallback(() => {
        window.dataLayer.push(props.analyticsArgument);
    }, [props.analyticsArgument]);

    return (
        <article className="fact-container">
            <div className="fact-data">
                <h2>Did you know</h2>
                <div className="fact-underline"></div>
                <p className="h3">{props.data.didYouKnow}</p>
                <a className="source" onClick={onSourceClick} href={props.data.didYouKnowSource} rel="noopener noreferrer" target="_blank">Source</a>
            </div>
        </article>
    );
};

export default Fact;
